import { Map } from "immutable";

import { ACTIONS } from "features/planner/planner.constants";
import { MarkerMapper } from "features/planner/planner.mappers";

const initialState = Map({});

export default (state = initialState, action) => {
  const { error, payload, type } = action;

  switch (type) {
    case ACTIONS.GET_MARKERS: {
      if (error) return state;

      return Map(
        payload.map(Marker => [
          Marker.markerId.toString(),
          MarkerMapper.from(Marker),
        ]),
      );
    }

    case ACTIONS.UPDATE_MARKER:
    case ACTIONS.CREATE_MARKER: {
      if (error) return state;

      return state.set(payload.markerId.toString(), MarkerMapper.from(payload));
    }

    case ACTIONS.DELETE_MARKER: {
      if (error) return state;

      return state.delete(action.markerId.toString());
    }

    default:
      return state;
  }
};
